import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tw-flex tw-gap-x-5px tw-items-center"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: 'La tua ricerca è stata salvata con successo'
}, null, -1 /* HOISTED */);
var _hoisted_4 = {
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_5 = {
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_6 = {
  class: "tw-flex tw-items-center tw-justify-start tw-pl-10px"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "max-sm:tw-max-w-[200px] tw-mt-5px sm:tw-flex"
}, " Richiedi una consulenza mutuo gratuita ", -1 /* HOISTED */);
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  id: "required-phone",
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-0"
};
var _hoisted_10 = {
  class: "tw-text-12 tw-ml-5px tw-mb-10px tw-mt-20px"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "tw-font-semibold"
}, "Conferma", -1 /* HOISTED */);
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  class: "tw-flex tw-justify-center"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  key: 0,
  class: "tw-text-w-danger tw-text-12",
  innerHTML: 'Si è verificato un errore'
};
import BaseToggle from "@vueEntry/UIKitComponents/BaseToggle.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { onBeforeMount, ref, computed } from "vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import { sendMortgage } from "@services/agencyAPI";
import { sendGAEvent } from "@utils/GaEvents";
import md5 from "blueimp-md5";
import GenericSuccessModal from "@vueEntry/Modals/GenericSuccessModal.vue";
import { addGenericRequest } from "@services/requestAPI";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf, helpers } from "@vuelidate/validators";
import { useValidator } from "@wkComposables/useValidator";
import { useCommonVars } from "@wkComposables/useCommonVars";
export default /*#__PURE__*/_defineComponent({
  __name: 'SaveSearchSuccessModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    labels: {},
    isUserLogged: {
      type: Boolean
    },
    email: {},
    name: {
      default: ""
    },
    realEstateSearchBean: {},
    pageName: {
      default: ""
    },
    publicUserId: {}
  },
  emits: ["closedModal"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var show = ref(false);
    var showError = ref(false);
    var showMessageSentSuccess = ref(false);
    var isLoading = ref(false);
    /*const isValidPhone = ref(null as Nullable<boolean>)*/
    var requestData = ref({
      toggleGeneric: false,
      toggleMortgage: false,
      email: "",
      name: null,
      phone: null
    });
    var rules = computed(() => {
      return {
        requestData: {
          phone: {
            requiredIf: requiredIf(() => {
              return requestData.value.toggleGeneric || requestData.value.toggleMortgage;
            }),
            isValidPhone: helpers.regex(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/)
          },
          name: {
            requiredIf: requiredIf(() => {
              return !props.isUserLogged && (requestData.value.toggleGeneric || requestData.value.toggleMortgage);
            })
          }
        }
      };
    });
    var {
      isValid
    } = useValidator();
    var {
      wkLabels
    } = useCommonVars();
    var v$ = useVuelidate(rules, {
      requestData
    });
    onBeforeMount(() => {
      show.value = props.showModal;
      requestData.value.email = props.email;
      requestData.value.name = props.name;
    });
    var {
      cdn
    } = useCommonVars();
    var closedModal = () => {
      emits("closedModal");
    };
    var submitRequest = () => __awaiter(this, void 0, void 0, function* () {
      isLoading.value = true;
      var event_location = "".concat(props.pageName, " - Modale salva ricerca - Success");
      var mortgageData = {
        name: props.isUserLogged ? props.name : requestData.value.name,
        email: props.email,
        phone: requestData.value.phone,
        tenant: 1,
        realEstateSearchBean: props.realEstateSearchBean
      };
      try {
        if (requestData.value.toggleGeneric) {
          sendGAEvent("generic_request_lead", {
            event_location: event_location,
            real_estate_place_id: null,
            real_estate_contract_type: null,
            real_estate_typology_name: null,
            real_estate_typology_id: null,
            user_email_hashed: md5(props.email),
            user_email: props.email,
            user_id: props.publicUserId === -1 ? null : props.publicUserId
          });
          yield addGenericRequest({
            sale: props.realEstateSearchBean.sale,
            rent: props.realEstateSearchBean.rent,
            auction: props.realEstateSearchBean.auction,
            priceSale: props.realEstateSearchBean.priceFrom,
            priceRent: props.realEstateSearchBean.priceFrom,
            auctionMinimumOffer: props.realEstateSearchBean.auctionMinimumOffer,
            typologyId: props.realEstateSearchBean.typologyId,
            macroTypologyId: props.realEstateSearchBean.macroTypologyId,
            cityId: props.realEstateSearchBean.cityId,
            zoneId: props.realEstateSearchBean.zoneId,
            provinceId: props.realEstateSearchBean.provinceId,
            regionId: props.realEstateSearchBean.regionId,
            districtId: props.realEstateSearchBean.districtId,
            name: props.isUserLogged ? props.name : requestData.value.name,
            email: props.email,
            phone: requestData.value.phone
          });
        }
        if (requestData.value.toggleMortgage) {
          yield sendMortgage(mortgageData);
          sendGAEvent("mortgage", {
            event_location
          });
        }
        isLoading.value = false;
        if (requestData.value.toggleMortgage || requestData.value.toggleGeneric) showMessageSentSuccess.value = true;else closedModal();
      } catch (err) {
        console.error(err);
        showError.value = true;
      }
    });
    /*
    const checkIfValidPhone = (): boolean => {
        const validPhone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
        isValidPhone.value = validPhone.test(requestData.value?.phone);
        return isValidPhone.value
    }
    */
    var openWikiPrivacy = () => {
      var privacyUrl = "/privacy/#informativa-j";
      window.open(privacyUrl, "_blank", "scrollbars=yes, width=550, height=600");
    };
    return (_ctx, _cache) => {
      return showMessageSentSuccess.value ? (_openBlock(), _createBlock(GenericSuccessModal, {
        key: 0,
        "show-modal": showMessageSentSuccess.value,
        labels: {
          actual_title: "Richiesta inviata",
          actual_label: "La richiesta \xE8 stata inviata correttamente"
        },
        "auto-close": 3000,
        onClosed: closedModal
      }, null, 8 /* PROPS */, ["show-modal"])) : (_openBlock(), _createBlock(BaseBtModal, {
        key: 1,
        id: "share-modal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => show.value = $event),
        "data-cy": "share-modal",
        "show-modal": show.value,
        "custom-modal-dialog-classes": "modal-lg",
        "with-custom-footer": true,
        onClosed: closedModal
      }, {
        header: _withCtx(() => [_createVNode(BaseAlert, {
          "alrt-class": "tw-alert tw-alert-w-primary tw-mr-35px !tw-mb-0"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
            src: "".concat(_unref(cdn), "/_ui/img/Ico/icon-done-blue.svg"),
            width: "20",
            height: "20",
            alt: "done icon"
          }, null, 8 /* PROPS */, _hoisted_2), _hoisted_3])]),
          _: 1 /* STABLE */
        })]),
        body: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(BaseToggle, {
          modelValue: requestData.value.toggleGeneric,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => requestData.value.toggleGeneric = $event),
          label: 'Voglio ricevere proposte simili da agenzie immobiliari',
          class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px tw-text sm:tw-text-16 tw-font-medium"
        }, null, 8 /* PROPS */, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(BaseToggle, {
          modelValue: requestData.value.toggleMortgage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => requestData.value.toggleMortgage = $event),
          label: '',
          class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px tw-text sm:tw-text-16 tw-font-medium"
        }, {
          rightLabel: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("img", {
            class: "tw-mx-5px tw-w-auto sm:tw-block",
            width: "73",
            height: "25",
            src: "".concat(_unref(cdn), "/_ui/img/adv/credipass-logo-new.webp"),
            alt: "logo credipass"
          }, null, 8 /* PROPS */, _hoisted_8)])]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_9, [!_ctx.isUserLogged ? (_openBlock(), _createBlock(BaseInput, {
          key: 0,
          id: "name",
          modelValue: requestData.value.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => requestData.value.name = $event),
          name: "name",
          "label-text": "Nome",
          "is-valid": _unref(isValid)(_unref(v$).requestData.name)
        }, null, 8 /* PROPS */, ["modelValue", "is-valid"])) : _createCommentVNode("v-if", true), _createVNode(BaseInput, {
          id: "phone",
          modelValue: requestData.value.phone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => requestData.value.phone = $event),
          name: "phone",
          type: "tel",
          "label-text": "Telefono",
          "is-valid": _unref(isValid)(_unref(v$).requestData.phone)
        }, null, 8 /* PROPS */, ["modelValue", "is-valid"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_createTextVNode(" Cliccando "), _hoisted_11, _createTextVNode(", dichiaro di aver preso visione dell' "), _createElementVNode("span", {
          innerHTML: _unref(wkLabels).privacyPolicy2
        }, null, 8 /* PROPS */, _hoisted_12), _createTextVNode(" ("), _createElementVNode("a", {
          class: "tw-underline",
          href: "#",
          onClick: _withModifiers(openWikiPrivacy, ["prevent"]),
          innerHTML: _unref(wkLabels).purpose + ' J'
        }, null, 8 /* PROPS */, _hoisted_13), _createTextVNode(") ")])])], 512 /* NEED_PATCH */), [[_vShow, requestData.value.toggleGeneric || requestData.value.toggleMortgage]])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(BaseButton, {
          "data-cy": "sss-modal-confirm",
          class: "tw-self-start tw-mx-0 sm:tw-mx-auto tw-w-full w-sm-auto sm:tw-max-w-[172px] tw-mt-20px sm:tw-mt-0",
          "btn-class": "tw-btn-w-primary",
          "is-loading": isLoading.value,
          disabled: (requestData.value.toggleGeneric || requestData.value.toggleMortgage) && (_unref(v$).requestData.phone.$invalid || _unref(v$).requestData.name.$invalid),
          onClick: _withModifiers(submitRequest, ["stop"])
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            innerHTML: _ctx.labels.genericConfirm
          }, null, 8 /* PROPS */, _hoisted_15)]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-loading", "disabled"]), showError.value ? (_openBlock(), _createElementBlock("span", _hoisted_16)) : _createCommentVNode("v-if", true)])]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "show-modal"]));
    };
  }
});